import axios from 'axios';
import { get } from 'lodash';

export type BuildingItemType = {
  kayitNo: number;
  csbm: {
    kayitNo: number;
    mahalle: {
      kayitNo: number;
      koy: {
        kayitNo: number;
        bucak: {
          kayitNo: number;
          ilce: {
            kayitNo: number;
            il: {
              kayitNo: number;
              ilKodu: number;
              ilAdi: string;
            };
            ilceKodu: number;
            ilceAdi: string;
          };
          bucakKodu: number;
          bucakAdi: string;
        };
        koyKodu: number;
        koyAdi: string;
      };
      mahalleAdi: string;
      mahalleKodu: number;
    };
    prmCsbmTurKod: {
      kod: number;
      aciklama: string;
    };
    csbmAdi: string;
    koordinatId: number;
    koordX: string;
    koordY: string;
  };
  siteAdi: string;
  blokAdi: string;
  postaKodu: string | null;
  binaNo: number;
  disKapiNo1: string;
  disKapiNo2: string | null;
};

const getBuildingList = async (kayitNo: string): Promise<BuildingItemType[]> => {
  const url = `https://api.ibb.gov.tr/ibb-adres-api/adres/csbm/bina/${kayitNo}`;

  const response = await axios.get(url);

  return get(response, 'data', []);
};

export default getBuildingList;
